import { render } from "./FilterAccordion.vue?vue&type=template&id=c6989650&scoped=true"
import script from "./FilterAccordion.vue?vue&type=script&lang=ts"
export * from "./FilterAccordion.vue?vue&type=script&lang=ts"

import "./FilterAccordion.vue?vue&type=style&index=0&id=c6989650&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c6989650"

export default script